<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Non IATA {{ $t('Periodic-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
 <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
        </v-layout>
<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
        <v-container fluid="">
          <v-card flat>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" v-model="Rapor.BaslangicTarih"
                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" v-model="Rapor.BitisTarih"
                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>
                </v-flex>

                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                      <div v-if="load1==false">
                            <v-layout fill-height align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green">
                          check_circle_outline </v-icon>
                      </template>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>



                    </v-badge>
                  </v-layout>
                </v-flex>

              </v-layout>
            </v-form>

            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="#66BB6A">
                          <v-toolbar-title> <span class="subheading white--text">
                            {{ $t('Tickets-Sold') }}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-flex xs6 sm6 md6>
                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"
                              :label="$t('Search')" append-icon="search"></v-text-field>
                          </v-flex>
                        </v-toolbar>

                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-card flat>
                          <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :items="itemssatis"
                            :search="searchsatilanbilet">
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                              <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tarih | dateformat}}</td>
                              <td class="text-xs-right">{{ props.item.UcusTipi }}</td>
                              <td class="text-xs-right">{{ props.item.YolcuAdi }}</td>
                              <td class="text-xs-right">{{ props.item.Parkurlar }}</td>
                                       <td class="text-xs-right">{{ props.item.CariKod }}</td>
                                <td class="text-xs-right">{{ props.item.MasrafMerkeziKodu }}</td>
                                <td class="text-xs-right">{{ props.item.MasrafMerkeziAdi }}</td>
                                <td class="text-xs-right">{{ props.item.FaturaNo }}</td>
                              <td class="text-xs-left">{{ props.item.S }}</td>
                              <td class="text-xs-left">{{ props.item.Tutar | moneyformat }}</td>
                              <td class="text-xs-left">{{ props.item.Vergi | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.Komisyon | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.AlisServis | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.Net | moneyformat }}</td>


                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2
                        xs12 sm12 md12>
                        <v-layout align-center="" justify-center="" fill-height="">
                          <span class="title grey--text font-weight-bold">
                            {{ $t('General-Totals-Tickets-Sold') }}
                          </span>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>


                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Tutar
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Tax-v2')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Purchase-Service') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Net') }}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Adet}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Tutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Vergi | moneyformat}}{{getparabirimi()}}</span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Komisyon | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.AlisServis | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Net | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-chip color="green"> <span class="subheading white--text"> Satılan Bilet Toplamlar </span>
                                </v-chip>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Adet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Alan + Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Tutar}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Gross') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Vergi}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Penalty')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Komisyon}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.AlisServis}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Service')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Net}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <br />
            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="red">
                          <v-toolbar-title> <span class="subheading white--text">
                              İade Biletler
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-flex xs6 sm6 md6>
                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet" :label="$t('Search')"
                              append-icon="search"></v-text-field>
                          </v-flex>
                        </v-toolbar>
                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-card flat>
                          <v-data-table :headers="headersiade" :rows-per-page-items=[20,100] :items="itemsiade"
                            :search="searchiadebilet">
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item.HavayoluKodu }}</td>
                              <td class="text-xs-left">{{ props.item.BiletNo }}</td>
                              <td class="text-xs-left">{{ props.item.Tarih | dateformat}}</td>
                              <td class="text-xs-right">{{ props.item.UcusTipi }}</td>
                              <td class="text-xs-right">{{ props.item.YolcuAdi }}</td>
                              <td class="text-xs-right">{{ props.item.Parkurlar }}</td>
                                       <td class="text-xs-right">{{ props.item.CariKod }}</td>
                                <td class="text-xs-right">{{ props.item.FaturaNo }}</td>
                              <td class="text-xs-left">{{ props.item.S }}</td>
                              <td class="text-xs-left">{{ props.item.Tutar | moneyformat }}</td>
                              <td class="text-xs-left">{{ props.item.Vergi | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.Komisyon | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.AlisServis | moneyformat}}</td>
                              <td class="text-xs-left">{{ props.item.Net | moneyformat }}</td>
                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                 {{ $t('No-records-searched-for', { value: searchiadebilet}) }}
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2
                        xs12 sm12 md12>
                        <v-layout align-center="" justify-center="" fill-height="">
                          <span class="title grey--text font-weight-bold">
                            {{$t('Sums-of-Refunded-Tickets')}}
                          </span>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>


                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Tutar
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Tax-v2')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Purchase-Service') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Net') }}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Adet}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Tutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Vergi | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Komisyon | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.AlisServis | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Net | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-chip color="red"> <span class="subheading white--text"> İade Bilet Toplamlar </span>
                                </v-chip>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Adet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Alan + Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Tutar}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">  {{ $t('Gross') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Vergi}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Penalty')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Komisyon}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.AlisServis}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Service')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Net}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>


                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <br />
            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="info">
                          <v-toolbar-title> <span class="subheading white--text">
                              {{ $t('General-Totals') }}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>

                        </v-toolbar>
                      </v-flex>


                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>


                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Tutar
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Tax-v2')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Purchase-Service') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Net')}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Adet}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Tutar | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Vergi | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Komisyon | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.AlisServis | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Net | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Number')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Adet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Alan + Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Tutar}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">  {{ $t('Gross') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Vergi}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Penalty')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Komisyon}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Commission')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.AlisServis}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Servis
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Net}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>


                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

          </v-card>
        </v-container>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>


        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
          <v-card color="grey lighten-5">
            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>

              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout row="" wrap="">

                      <v-flex xs12 sm12 md12>
                        <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>
                        <havayollaricomp :etiket="'Acenta Kodu'" v-model="havayolubil2"></havayollaricomp>
                        <v-autocomplete v-if="!simpleMode" hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi"
                          :label="$t('Expense-Center-v2')" item-text="Title" clearable item-value="Code" max-height="400">
                        </v-autocomplete>
                      </v-flex>


                      <v-flex xs12 sm12 md12>
                        <div class="card__text grey darken-1 white--text">
                          <h3>{{$t('Options')}}</h3>
                        </div>
                      </v-flex>

                      <div class="flex md4">
                        <v-radio-group :label="$t('Ticket-Type')" v-model="Rapor.HatTipi" hide-details>
                          <v-radio :value="0" :label="$t('All')"></v-radio>
                          <v-radio :value="1" :label="$t('Domestic-Line')"></v-radio>
                          <v-radio :value="2" :label="$t('International-Line')"></v-radio>
                          <v-radio :value="3" label="BSP"></v-radio>
                          <v-radio :value="4" label="BSP+ Dış"></v-radio>

                        </v-radio-group>
                      </div>

                      <div v-if="!simpleMode" class="flex md4">
                        <v-radio-group :label="$t('Payment')" v-model="Rapor.OdemeTipi" hide-details>
                          <v-radio :value="0" :label="$t('All')"></v-radio>
                          <v-radio :value="1" :label="$t('Cash')"></v-radio>
                          <v-radio :value="2" :label="$t('Credit-Card')"></v-radio>
                        </v-radio-group>
                      </div>


                      <div class="flex md4">
                        <v-radio-group :label="$t('Raport-Order')" v-model="Rapor.RaporSira" hide-details>
                          <v-radio :value="0" :label="$t('Ticket-Order')"></v-radio>
                          <v-radio :value="1" label="Tarih Sırası"></v-radio>
                        </v-radio-group>
                      </div>

                      <div class="flex md6">
                        <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                      </div>


                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
              <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"


  export default {
    data() {
      return {
        mailDialog: false,
        simpleMode: false,
                        mailValid: false,
                        mailLoading: false,
                        mailPayload: {
                          To: "",
                          AgencyName: "",
                          DocType: "Non IATA Devre Raporu - Non IATA Periodic Report", 
                          AgentFullName: "",
                          CustomBody: ""
                        },
                        rules: {
                          required: v => !!v || 'Zorunlu alan',
                          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
                        },
         sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        searchsatilanbilet: null,
        searchiadebilet: null,
        itemssatis: [],
        itemsiade: [],
        doviztipi: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        havayolubil2: {
          havayolukodu: null,
          formno: null
        },
        search: '',
        satisGen: {
          Adet: 0,
          AlisServis: 0,
          Vergi: 0,
          Tutar: 0,
          Komisyon: 0,
          Net: 0,
        },
        iadeGen: {
          Adet: 0,
          AlisServis: 0,
          Vergi: 0,
          Tutar: 0,
          Komisyon: 0,
          Net: 0,
        },
        gengen: {
          Adet: 0,
          AlisServis: 0,
          Vergi: 0,
          Tutar: 0,
          Komisyon: 0,
          Net: 0,
        },
        Rapor: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavaYoluKodu: null,
          AcentaKodu: null,
          Masraf: null,
          OdemeTipi: 0, // 0 : hepsi, 1 : peşin, 2 : kredi kart
          RaporSira: 0, // 0 : Bilet sirası, 1 : Tarih sirasi
          HatTipi: 0 // 0 : hepsi, 1 : iç, 2 : dis, 3 : Dis, 4 : Bsp, 5 : bsp+dis
        },
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        valid: true,
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsvoid: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.simpleModeYukle();
     this.simpleModeDefaultlariUygula();
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });
      } 
      
    },

    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },
    components: {
      'tarihcomp': tarihcomp,
      havayollaricomp,
      parkurcomp,
      yetkidialog
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
      simpleModeYukle() {
  var manageload = null;

  try {
    manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));
  } catch (e) {
    manageload = null;
  }

  if (manageload && manageload.UserInfo) {
    this.simpleMode =
      manageload.UserInfo.SimpleMode === true ||
      manageload.UserInfo.SimpleMode === 1 ||
      manageload.UserInfo.SimpleMode === "1" ||
      manageload.UserInfo.SimpleMode === "true";
  }
},

simpleModeDefaultlariUygula() {
  if (!this.simpleMode) {
    return;
  }

  this.Rapor.Masraf = null;
  this.Rapor.OdemeTipi = 0;
},
  openMailDialog: function () {
    var pageDocType = "Non IATA Devre Raporu - Non IATA Periodic Report";
    if (!this.mailPayload) this.mailPayload = {};
    this.mailPayload.DocType = pageDocType;

    // sadece validasyon hatalarını temizle
    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }
    this.mailDialog = true;
  },

  closeMailDialog: function () {
    this.mailDialog = false;
  },

  sendMail: function () {
    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    var bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;
    var bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;
    if (!(bas && bit && bas <= bit)) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    var credentialsRaw = window.localStorage.getItem('credentials');
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    var companyCode = (_this.tumsirketler === true)
      ? 0
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var havaYoluKodu = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;
    var acentaKodu  = (_this.havayolubil2 && _this.havayolubil2.havayolukodu) ? _this.havayolubil2.havayolukodu : null;

    var R = _this.Rapor || {};
    var inputObj = {
      SirketKodu: companyCode,
      BaslangicTarih: R.BaslangicTarih || null,
      BitisTarih: R.BitisTarih || null,
      HavaYoluKodu: havaYoluKodu,
      AcentaKodu: acentaKodu,
      Masraf: R.Masraf || null,
      OdemeTipi: (typeof R.OdemeTipi !== 'undefined') ? R.OdemeTipi : 0, 
      RaporSira: (typeof R.RaporSira !== 'undefined') ? R.RaporSira : 0, 
      HatTipi:   (typeof R.HatTipi   !== 'undefined') ? R.HatTipi   : 0  
    };

    var pageDocType = "Non IATA Devre Raporu - Non IATA Periodic Report";
    var mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : pageDocType,
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketPeriodReport/MailGonderNonIATADevreRaporuExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      var msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },


          getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    },
    computed:{

      
        headerssatis1(){
          return [{
            text: 'HY',
            value: 'HavayoluKodu'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip'
          },
          {
            text: this.$t('Account'),
            value: 'Cari.Kod'
          },
          {
            text: this.$t('Ticket-Amount'),
            value: 'BiletTutari'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'VergiTutari'
          },
          {
            text: this.$t('Discount'),
            value: 'IskontoTutari'
          },
          {
            text: this.$t('Service'),
            value: 'ServisTutari'
          },
          {
            text: this.$t('Reserve'),
            value: 'ReserveTutari'
          },
          {
            text: this.$t('With-Credit'),
            value: 'KrediliTutar'
          },
          {
            text: this.$t('Cash'),
            value: 'PesinTutar'
          },
          {
            text: this.$t('With-Credit-Card'),
            value: 'KrediKartTutar'
          },
          {
            text: this.$t('Credit-Card-No'),
            value: 'KrediKartNo'
          },
          {
            text: this.$t('Invoice-No'),
            value: 'FaturaNo'
          },
          {
            text: this.$t('Penalty'),
            value: 'CezaTutari'
          }
        ]
        },
        headervoid(){
          return [{
            text: 'HY',
            value: 'HavayoluKodu'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip'
          },
          {
            text: this.$t('Description'),
            value: ''
          }

        ]
        },
      

        headerssatis(){
          return [{
            text: 'HY',
            value: 'HavayoluKodu',
            width: "10%",
          }, {
            text: this.$t('Ticket-No'),
            value: 'BiletNo',
            width: "10%",
          }, {
            text: this.$t('Date'),
            value: 'Tarih',
            width: "10%",
            align: 'left'
          }, {
            text: this.$t('Line-Type'),
            value: 'UcusTipi',
            width: "1%",
          },

          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
            width: "10%",
          },
          {
            text: this.$t('Route'),
            value: 'Parkurlar',
            width: "10%",
          }
          ,{
            text: this.$t('Current'),
            value: 'CariKod',
            width: "10%",
            align: 'left'
          },{
            text: this.$t('Expense-Center-v2'),
            value: 'MasrafMerkeziKodu',
            width: "10%",
            align: 'left'
          },{
            text: this.$t('Expense-Centre-Name'),
            value: 'MasrafMerkeziAdi',
            width: "10%",
            align: 'left'
          },{
            text: this.$t('Invoice-No'),
            value: 'FaturaNo',
            width: "10%",
            align: 'center'
          },
          {
            text: 'S',
            value: 'S',
            width: "10%",
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            width: "10%",
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Vergi',
            width: "10%",
          },
          {
            text: this.$t('Commission'),
            value: 'Komisyon',
            width: "10%",
          },
          {
            text: this.$t('Purchase-Service'),
            value: 'AlisServis',
            width: "10%",
          },
          {
            text: this.$t('Net'),
            value: 'Net',
            width: "0%",
          },

        ]
        },


        headersiade(){
          return [{
            text: 'HY',
            value: 'HavayoluKodu',
            width: "10%",
          }, {
            text: this.$t('Ticket-No'),
            value: 'BiletNo',
            width: "10%",
          }, {
            text: this.$t('Date'),
            value: 'Tarih',
            width: "10%",
            align: 'left'
          }, {
            text: this.$t('Line-Type'),
            value: 'UcusTipi',
            width: "1%",
          },

          {
            text: this.$t('Name-of-Passenger'),
            value: 'YolcuAdi',
            width: "10%",
          },
          {
            text: this.$t('Route'),
            value: 'Parkurlar',
            width: "10%",
          }
          ,{
            text: this.$t("Currentcode_label"),
            value: 'CariKod',
            width: "10%",
            align: 'left'
          },{
            text: 'Dekont No',
            value: 'FaturaNo',
            width: "10%",
            align: 'center'
          },
          {
            text: 'S',
            value: 'S',
            width: "10%",
          },
          {
            text: this.$t('Amount'),
            value: 'Tutar',
            width: "10%",
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Vergi',
            width: "10%",
          },
          {
            text: this.$t('Commission'),
            value: 'Komisyon',
            width: "10%",
          },
          {
            text: this.$t('Purchase-Service'),
            value: 'AlisServis',
            width: "10%",
          },
          {
            text: this.$t('Net'),
            value: 'Net',
            width: "0%",
          },

        ]
        },

        fiyatturu(){
          return [{
            text: 'AD-' + this.$t('Adult'),
            value: 'AD'
          },
          {
            text: 'CHD-' + this.$t('Child'),
            value: 'CHD'
          },
          {
            text: 'INF-' + this.$t('Baby'),
            value: 'INF'
          },
          {
            text: 'TUS-' + this.$t('Diplomatic'),
            value: 'TUS'
          },
          {
            text: 'EX',
            value: 'EX'
          },
          {
            text: 'STD-' + this.$t('Student'),
            value: 'STD'
          },
          {
            text: 'SRC-' + this.$t('Elderly'),
            value: 'SRC'
          },
          {
            text: 'MIL-' + this.$t('Soldier'),
            value: 'MIL'
          },
          {
            text: 'YTH-' + this.$t('Young'),
            value: 'YTH'
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true
    this.simpleModeYukle();
  this.simpleModeDefaultlariUygula();


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }




    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {

      } else {

      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.getList()
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false
    this.Rapor.SirketKodu = null
    this.Rapor.HavaYoluKodu = null
    this.havayolubil.havayolukodu=null
    this.havayolubil2.havayolukodu=null
    this.tumsirketler=false
    this.Rapor.AcentaKodu = null
    this.Rapor.Masraf = null
    this.Rapor.OdemeTipi = 0 // 0 : hepsi, 1 : peşin, 2 : kredi kart
    this.Rapor.RaporSira = 0 // 0 : Bilet sirası, 1 : Tarih sirasi
    this.Rapor.HatTipi = 0 // 0 : hepsi, 1 : iç, 2 : dis, 3 : Dis, 4 : Bsp, 5 : bsp+dis
  }





  function getList() {
    this.simpleModeYukle();
  this.simpleModeDefaultlariUygula();


    if (this.$refs.formgunluksatis.validate()) {


      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {



        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
        this.Rapor.AcentaKodu = this.havayolubil2.havayolukodu;

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketPeriodReport/NonIataPeriodReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemssatis = response.body.SatisBilgi.SatisListe
          this.itemsiade = response.body.IadeBilgi.IadeListe

          this.satisGen = response.body.SatisBilgi.SatisToplamlar
          this.iadeGen = response.body.IadeBilgi.IadeToplamlar
          this.gengen = response.body.GenelToplamlar


          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }

        })
      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }

    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
      this.Rapor.AcentaKodu = this.havayolubil2.havayolukodu;

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/NonIataPeriodReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "NonIataDevre.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
      this.Rapor.AcentaKodu = this.havayolubil2.havayolukodu;

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/NonIataPeriodReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "NonIataDevre.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })

    }
  }

  function beforeMount() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })
  }



  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>
<style>
</style>